import { IGroup } from "../classes/interfaces";
import { isGroupIconSlug } from "../components/ui/Icon/groupIconOptions";

// Mapeia o nome do grupo (vindo do OnChef) para um ícone do design system.
// É o padrão quando o dono da loja não escolheu nada.
export function groupIcon(groupName: string): string {
  const name = groupName
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
  if (/pizza/.test(name)) return "pizzaSlice";
  if (/burguer|burger|lanche|hamb|sanduiche/.test(name)) return "burger";
  if (/cerveja|chopp|beer/.test(name)) return "beer";
  if (/refri|agua|suco/.test(name)) return "bottle";
  if (/bebida|drink|vinho|whisky|vodka|dose|copo/.test(name)) return "cup";
  if (/combo|promo|destaque/.test(name)) return "flame";
  return "utensils";
}

/**
 * Ícone efetivo de um grupo: a escolha do dono da loja quando existe e é
 * válida, senão a dedução pelo nome.
 */
export function resolveGroupIcon(group: Pick<IGroup, "name" | "icon">): string {
  return isGroupIconSlug(group.icon) ? group.icon : groupIcon(group.name);
}
